export const PAYPAL_EXPRESS_PAYMENT_ID = 400;
